import { createActionCreators } from '../actions/optionsBase';

const OPEN_DATA_SETTINGS_DIALOG = 'OPEN_DATA_SETTINGS_DIALOG';
const APPLY_DATA_SETTINGS_DIALOG = 'APPLY_DATA_SETTINGS_DIALOG';
const CANCEL_DATA_SETTINGS_DIALOG = 'CANCEL_DATA_SETTINGS_DIALOG';

export const openDataSettingsDialog = () => ({
  type: OPEN_DATA_SETTINGS_DIALOG,
  payload: null,
});

export const applyDataSettingsDialog = () => ({
  type: APPLY_DATA_SETTINGS_DIALOG,
  payload: null,
});

export const cancelDataSettingsDialog = () => ({
  type: CANCEL_DATA_SETTINGS_DIALOG,
  payload: null,
});

export const prefix = 'DATA_SETTINGS';

export const actions = createActionCreators(prefix);

export const types = {
  OPEN_DATA_SETTINGS_DIALOG,
  APPLY_DATA_SETTINGS_DIALOG,
  CANCEL_DATA_SETTINGS_DIALOG,
};



// WEBPACK FOOTER //
// ./src/actions/dataSettingsDialog.js